import * as React from 'react'
import { List } from './List'
import { AsyncPostStatus, AsyncPost } from './utils';
import { StoreQuoteData, EQuoteType } from './models';

interface IProps {
    quote: number,
    sendQuoteByEmail: AsyncPost<StoreQuoteData, any>
    handleEmailQuoteBtnClick: () => void
    handleAcceptBtnClick: (quoteType: EQuoteType) => void
}

export function RepairQuote({ quote, sendQuoteByEmail, handleEmailQuoteBtnClick, handleAcceptBtnClick }: IProps) {
    var sendQuoteByEmailContent, quoteFixed;

    if (sendQuoteByEmail.status == AsyncPostStatus.NONE) {
        sendQuoteByEmailContent = (
            <button
                className="cc-quote__email-quote-btn btn btn-link btn-cc-green"
                onClick={handleEmailQuoteBtnClick}
            >
                Email me the quote
            </button>
        )
    }
    if (sendQuoteByEmail.status == AsyncPostStatus.POSTING) {
        sendQuoteByEmailContent = (
            <p>
                Sending quote to {sendQuoteByEmail.data.contact.email} ...
            </p>
        )
    }
    if (sendQuoteByEmail.status == AsyncPostStatus.POSTED) {
        sendQuoteByEmailContent = (
            <p>
                <i className="glyphicon glyphicon-ok"/> Sent
            </p>
        )
    }
    if (sendQuoteByEmail.status == AsyncPostStatus.ERROR) {
        sendQuoteByEmailContent = (
            <div>
                <div className="text-danger">
                    {sendQuoteByEmail.error}
                </div>
                <button
                    className="cc-quote__email-quote-btn btn btn-link btn-cc-green"
                    onClick={handleEmailQuoteBtnClick}
                >
                    Email me the quote
                </button>
            </div>
        )
    }

    if (quote !== null) {
        quoteFixed = quote.toFixed(2);
    }

    return (
        <div className="cc-quote__item">
            <div className="row">
                <div className="col-xs-12 text-center">
                    <span className="cc-quote__title">To repair your phone is:</span>
                    <span className="cc-quote__amount">R{quoteFixed}</span>
                    This includes:
                    <List
                        className="cc-quote__list"
                        listStyle="check"
                        items={[
                            '12-month warranty so you know we’ve got you covered',
                            'Free, insured collection and delivery for extra peace of mind',
                            'Your money back in full if you’re not happy with the repair',
                            '10% discount on any future repairs'
                        ]}
                    />
                </div>
            </div>
            {/*<div className="row cc-quote__buttons-wrapper">
                <div className="col-xs-6 text-center">
                    <button className="cc-quote__email-quote-btn btn btn-success btn-lg btn-cc-green" onClick={handleEmailQuoteBtnClick}>Email me the quote</button>
                </div>
                <div className="col-xs-6 text-center">
                    <button className="cc-quote__accept-btn btn btn-success btn-lg btn-cc-green" onClick={handleAcceptBtnClick}>Yes, Repair my device</button>
                </div>
            </div>*/}
            <div className="cc-quote__buttons-wrapper text-center">
                <div>
                    <button
                        className="cc-quote__accept-btn btn btn-success btn-lg btn-cc-green"
                        onClick={() => handleAcceptBtnClick(EQuoteType.CollectAndRepair)}
                    >
                        Yes, Collect & Repair
                    </button>
                </div>
                <div className="cc-quote__paragraph">
                    *Collect & Repair is available nationwide
                </div>
                {/* NOTE: commented since it can be used some day */}
                {/* <div className="cc-quote__email-quote-btn-wrapper">
                    {sendQuoteByEmailContent}
                </div> */}
            </div>
        </div>
    )
}
